import factory from "./factory";

export default function email(customMessage?: string) {
  const defaultMessage = "Not valid email";
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const rule = (x: string) => Promise.resolve(emailRegex.test(x));
  return factory(defaultMessage, customMessage, rule);
}
